import { CircleAlertIcon } from 'lucide-react';

export default function CampaignAfterCloseMessage({ regulationUrl }) {
  return (
    <div className="mb-8 flex w-full flex-row flex-wrap items-center justify-center gap-2 rounded-xl border border-portal-primary bg-portal-primary/10 p-4 text-portal-text shadow-sm sm:flex-nowrap">
      <CircleAlertIcon className="size-8 md:size-6" />
      <p>
        A campanha fechou ao público, obrigado pela sua participação. Pode
        consultar o regulamento{' '}
        <a
          href={regulationUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          aqui
        </a>
        .
      </p>
    </div>
  );
}
